"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Box_1 = __importDefault(require("../../layouts/Box"));
const Text_1 = __importDefault(require("../Text"));
/**
 * Key/value pairs are lists of properties (keys) followed by the corresponding value.
 */
const KeyValuePair = (_a) => {
    var { label, value } = _a, props = __rest(_a, ["label", "value"]);
    return (react_1.default.createElement(Box_1.default, { "data-testid": props['data-testid'] },
        react_1.default.createElement(Box_1.default, { color: "grey.600", fontSize: "body1.fontSize" }, label),
        react_1.default.createElement(Box_1.default, { "data-testid": "value", color: "text.primary" }, !value ? (react_1.default.createElement(Text_1.default, null, "-")) : typeof value === 'string' || typeof value === 'number' ? (react_1.default.createElement(Text_1.default, null, value)) : (react_1.default.createElement(react_1.default.Fragment, null, value)))));
};
exports.default = KeyValuePair;
//# sourceMappingURL=index.js.map